const locale = {
	TAB_EVALUATIONS: 'Valutazioni',
	TAB_COURSES: 'Corsi',

	// #region Users Skills
	TAB_SKILLS_USERS: 'Matrice Competenze',

	SKILLS_USERS_DIALOG_DETAILS_TITLE: '{user} - {skill}',
	SKILLS_USERS_DIALOG_DETAILS_ACTION_ADD: 'Aggiungi valutazione',
	// #endregion

	// #region Skills fields
	DETAILS_SKILLS_FIELD_TITLE: 'Titolo',
	DETAILS_SKILLS_FIELD_WARNING: 'Warning',
	DETAILS_SKILLS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_SKILLS_FIELD_TYPE: 'Tipo Competenza',
	DETAILS_SKILLS_FIELD_ASSIGNED_USER: 'Referente',
	DETAILS_SKILLS_FIELD_TAGS: 'Tag',
	// #endregion

	// #region Skills evaluations fields
	DETAILS_SKILLS_EVALUATIONS_FIELD_SKILL: 'Competenza',
	DETAILS_SKILLS_EVALUATIONS_FIELD_USER_ASSIGNED: 'Utente',
	DETAILS_SKILLS_EVALUATIONS_FIELD_LEVEL: 'Livello',
	DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_FROM: 'Data valutazione',
	DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_TO: 'Data scadenza',

	DIALOG_SKILLS_EVALUATIONS_ADD_TITLE: 'Aggiungi valutazione',
	DIALOG_SKILLS_EVALUATIONS_EDIT_TITLE: 'Modifica valutazione'
	// #endregion
};

export default locale;
